import React from "react";
import { AccentText } from "../i18n";
import KindTag from "./KindTag";
import BdfArchitecture from "./diagrams/BdfArchitecture";
import CwpArchitecture from "./diagrams/CwpArchitecture";
import FirmwareArchitecture from "./diagrams/FirmwareArchitecture";

const DIAGRAMS = {
  bdf: BdfArchitecture,
  cwp: CwpArchitecture,
  firmware: FirmwareArchitecture,
};

const Cwp = (props) => {
  const { dataSource } = props;
  const Diagram = DIAGRAMS[dataSource.id];
  const hasVisual =
    Boolean(Diagram) ||
    Boolean(dataSource.img) ||
    Boolean(dataSource.points);
  const isFile =
    dataSource.href &&
    (dataSource.href.endsWith(".pdf") || /^https?:\/\//.test(dataSource.href));

  const visual = (
    <>
      {Diagram && (
        <div className="nfw-media nfw-glass">
          <Diagram title={dataSource.imgAlt} />
        </div>
      )}
      {dataSource.img && !Diagram && (
        <div className="nfw-media nfw-glass">
          <img src={dataSource.img} alt={dataSource.imgAlt || ""} />
        </div>
      )}
      {!dataSource.img && !Diagram && dataSource.points && (
        <div className="nfw-points">
          {dataSource.points.map((item, i) => (
            <div className="nfw-point nfw-glass" key={item.title}>
              <b>{String(i + 1).padStart(2, "0")}</b>
              <div>
                <strong>{item.title}</strong>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );

  const heading = dataSource.title || dataSource.subtitle;
  const tagline =
    dataSource.subtitle && dataSource.subtitle !== heading
      ? dataSource.subtitle
      : null;
  const kicker =
    dataSource.eyebrow && dataSource.eyebrow !== heading
      ? dataSource.eyebrow
      : null;

  return (
    <section className={`nfw-section${dataSource.alt ? " nfw-section-alt" : ""}`}>
      <span className="nfw-anchor" id={dataSource.id} />
      <div className="nfw-wrap">
        <div
          className={`nfw-split${dataSource.reverse ? " reverse" : ""}${
            Diagram ? " nfw-split-top" : ""
          }`}
        >
          <div className="nfw-split-copy">
            {dataSource.kindLabel && (
              <div className="nfw-kind-row">
                <KindTag kind={dataSource.kind} label={dataSource.kindLabel} />
              </div>
            )}
            {kicker && <p className="nfw-kicker">{kicker}</p>}
            {heading && <h2>{heading}</h2>}
            {tagline && <p className="nfw-lead">{tagline}</p>}
            <div className="nfw-desc">
              <AccentText text={dataSource.desc} />
            </div>
            {dataSource.highlights && (
              <ul>
                {dataSource.highlights.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            )}
            {dataSource.button && (
              <a
                className="nfw-btn nfw-btn-solid"
                href={dataSource.href}
                target={isFile ? "_blank" : undefined}
                rel={isFile ? "noopener noreferrer" : undefined}
              >
                {dataSource.button}
              </a>
            )}
          </div>
          {hasVisual && <div>{visual}</div>}
        </div>
        {dataSource.metrics && (
          <div className="nfw-metrics nfw-metrics-below">
            {dataSource.metrics.map((item) => (
              <div className="nfw-metric nfw-glass" key={item.label}>
                <b>{item.value}</b>
                <span>{item.label}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Cwp;
